<a (click)="goBack()" class="arrow arrow-left" translate="add-account/gmb/locations/back-to-accounts"></a>

<mat-card>
  <mat-card-title [translate]="'gmb/locations/list'" [translateParams]="{ accountName: accountName }"></mat-card-title>
  <mat-card-subtitle>
    <div [innerHtml]="'add-account/gmb/locations/description-1' | translate"></div>
    <span translate="add-account/gmb/locations/description-2"></span>
  </mat-card-subtitle>
  <mat-card-content>
    <div class="filters">
      <button color="primary" (click)="selectFilteredLocations()" mat-button>
        <span translate="selector/select-all"></span>&nbsp;
        <span>(Max {{ MAX_CONNECTIONS_ALLOWED }})</span>
      </button>

      <button color="primary" (click)="unselectFilteredLocations()" mat-button>
        <span translate="selector/unselect-all"></span>
      </button>

      <div class="filters-wrapper">
        <app-select
          [control]="filtersGroup.get('statuses')"
          [items]="statusesChoicesList"
          [multiple]="true"
          labelKey="add-account/gmb/location/filters/status/label">
        </app-select>

        <app-select
          [control]="filtersGroup.get('openInformation')"
          [items]="openInformationChoicesList"
          [multiple]="true"
          labelKey="add-account/gmb/locations/open-info">
        </app-select>

        <app-select
          [control]="filtersGroup.get('operator')"
          [items]="operatorsChoicesList"
          labelKey="add-account/gmb/locations/filters/operators/label">
        </app-select>

        <mat-form-field>
          <mat-label [translate]="'add-account/gmb/locations/filters/name'"></mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input autocomplete="off" [formControl]="$any(filtersGroup.get('search'))" matInput />
          <mat-icon role="button" *ngIf="filtersGroup.value.search" (click)="clearSearch()" matSuffix> close </mat-icon>
        </mat-form-field>
      </div>
    </div>

    <div>
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="selection">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox
              *ngIf="connections[element.id].status !== ConnectionStatus.CONNECTING; else connectingGif"
              [class.disabled]="
                element.is_connected || connections[element.id].status === ConnectionStatus.AWAITING_CONNECTION
              "
              [ngClass]="connections[element.id].status"
              [disabled]="shouldDisableLocation(element)"
              (ngModelChange)="onLocationClick($event, element.id)"
              [(ngModel)]="connections[element.id].checked">
              <strong [translate]="'add-account/gmb/locations/status/' + connections[element.id].status"></strong>
            </mat-checkbox>
            <button
              color="primary"
              (click)="showErrors(element.id)"
              mat-button
              *ngIf="connections[element.id].status === ConnectionStatus.ERROR">
              <span translate="add-account/gmb/locations/status/error/button"></span>
            </button>

            <ng-template #connectingGif>
              <span class="connecting">
                <app-loader></app-loader>
                <strong [translate]="'add-account/gmb/locations/status/' + connections[element.id].status"></strong>
              </span>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="storeCode">
          <th mat-header-cell *matHeaderCellDef>
            <span translate="add-account/gmb/locations/store-code"></span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.storeCode; noStoreCode">
              {{ element.storeCode }}
            </span>
            <ng-template #noStoreCode>
              <span translate="gmb/locations/missing-store-code"> </span>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            <span translate="add-account/gmb/locations/name"></span>
          </th>
          <td mat-cell *matCellDef="let element">
            <strong translate="add-account/gmb/locations/already-authorized" *ngIf="element.is_connected"></strong>
            <span> {{ element.name }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef>
            <span translate="add-account/gmb/locations/address"></span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span> {{ element.addressLabel }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="open-info">
          <th mat-header-cell *matHeaderCellDef>
            <span translate="add-account/gmb/locations/open-info"></span>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.openInfo }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[5, 10, 15, 20]" showFirstLastButtons> </mat-paginator>
    </div>
  </mat-card-content>
  <mat-card-actions *ngIf="selectedLocationIds.size">
    <button
      [disabled]="loading || !canAddLocations()"
      (click)="finalizeAuthorization()"
      mat-raised-button
      color="primary">
      <span
        [translate]="
          selectedLocationIds.size > 1
            ? 'add-account/gmb/locations/connect-multiple'
            : 'add-account/gmb/locations/connect'
        "
        [translateParams]="{ numberOfLocationsToConnect: selectedLocationIds.size }"></span>
    </button>

    <button [disabled]="loading" (click)="cancel()" mat-raised-button>
      <span [translate]="'cancel'"></span>
    </button>
  </mat-card-actions>
</mat-card>

<ng-template #errorDetailTemplateRef>
  <span translate="add-account/gmb/locations/status/error/description/details"></span>
  <p class="details" [translate]="selectedError"></p>
</ng-template>
